/**
 * Superposition des habillages (Studio › « Superposition ») : la liste se lit
 * du dessus vers le dessous à l'antenne. Miroir de `backend/src/lib/cg-layer-order.ts`.
 */

/** Couche vidéo CasparCG d'un modèle d'habillage (le logo reste sur la 10). */
export function overlayVideoLayer(cgLayer: number): number {
  return 10 + cgLayer
}

/** Déplace l'entrée `index` de `delta` rangs ; rend la même liste hors bornes. */
export function moveInLayerOrder<T>(order: readonly T[], index: number, delta: number): readonly T[] {
  const target = index + delta
  if (index < 0 || index >= order.length || target < 0 || target >= order.length) return order
  const next = [...order]
  const [moved] = next.splice(index, 1)
  next.splice(target, 0, moved)
  return next
}

export function layerOrderChanged(initial: readonly string[], current: readonly string[]): boolean {
  return initial.length !== current.length || initial.some((id, index) => id !== current[index])
}
